import { useEffect, useState } from 'react';

import lookup from 'country-code-lookup';
import { City } from 'country-state-city';

function useCitiesByCountry(countryName) {
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!countryName || !countryName.trim()) {
      setCitiesOptions([]);
      return;
    }

    setLoading(true);
    setError(null);

    async function fetchCities() {
      try {
        const country = lookup.byCountry(countryName);

        if (!country) {
          throw new Error(`Country not found: ${countryName}`);
        }

        const allCities = City.getCitiesOfCountry(country?.iso2);
        const sortedCities = allCities.sort((a, b) => a.name.localeCompare(b.name));

        setCitiesOptions(sortedCities.map(city => ({ value: `${city.latitude}${city.longitude}`, label: city.name })));
      } catch (err) {
        setError(err.message || 'Failed to fetch cities');
      } finally {
        setLoading(false);
      }
    }

    fetchCities();
  }, [countryName]);

  return { citiesOptions, loading, error };
}

export default useCitiesByCountry;
